import BaseService from './BaseService';
import {
  ShipBobPerformanceSummary,
  ShipBobChannel,
  ProductCosts,
} from 'models/ShipBobPerformanceModel';

class ShipBobPerformanceService extends BaseService {
  async getSummary(params: {
    startDate: string;
    endDate: string;
    channelId?: string;
  }): Promise<ShipBobPerformanceSummary | null> {
    await this._getAccessToken();
    return this.handleHttpRequest<ShipBobPerformanceSummary>(
      () => this.http.get('shipbob-performance/summary', { params }),
      'Failed to fetch /shipbob-performance/summary',
    );
  }

  async getProductCosts(params: {
    startDate: string;
    endDate: string;
    channelId?: string;
  }): Promise<ProductCosts | null> {
    await this._getAccessToken();
    return this.handleHttpRequest<ProductCosts>(
      () => this.http.get('shipbob-performance/product-costs', { params }),
      'Failed to fetch /shipbob-performance/product-costs',
    );
  }

  async getChannels(): Promise<ShipBobChannel[] | null> {
    await this._getAccessToken();
    return this.handleHttpRequest<ShipBobChannel[]>(
      () => this.http.get('shipbob-performance/channels'),
      'Failed to fetch /shipbob-performance/channels',
    );
  }
}

export default ShipBobPerformanceService;
